export default __webpack_public_path__ + "static/media/ic-dashboard.4079a965.svg";